export const User = {
  SAVE_ACCOUNT: "SAVE_USER_ACCOUNT",
  SAVE_BMW_ACCOUNT: "SAVE_BMW_ACCOUNT",
  REMOVE_ACCOUNT: "REMOVE_USER_ACCOUNT",
  SAVE_VENDORS: "SAVE_VENDORS"
};

export const Common = {
  SPINNER_STATE: "SPINNER_STATE"
};

export const callVendor = {
  BYULDAERI: 1001,
  CHUNG_BANG: 10001
};

export const saleVendor = {
  BYULDAERI: 10401,
  CHUNG_BANG: 10001,
  KIA: 50001
};

export const vendorRoutePath = {
  BYULDAERI: "/bmw",
  CHUNG_BANG: "/chungbang",
  KIA: "/kia"
};



// WEBPACK FOOTER //
// ./src/store/mutation-types.js